// extracted by mini-css-extract-plugin
export var blueGradient = "styles-module--blue-gradient--N_Q2q";
export var cyanGradient = "styles-module--cyan-gradient--3FBkp";
export var orangeGradient = "styles-module--orange-gradient--7zfll";
export var purpleGradient = "styles-module--purple-gradient--2f2Dh";